import styled from 'styled-components';

export const CardRoot = styled.div<{
    $selected: boolean;
    $disabled?: boolean;
    $borderColor: string;
    $backgroundColor: string;
    $borderColorUnselected: string;
    $backgroundColorUnselected: string;
}>`
    width: 100%;
    border-radius: 12px;
    border: 1.5px solid
        ${({ $selected, $borderColor, $borderColorUnselected }) => ($selected ? $borderColor : $borderColorUnselected)};
    background: ${({ $selected, $backgroundColor, $backgroundColorUnselected }) => ($selected ? $backgroundColor : $backgroundColorUnselected)};
    opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
    pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

export const Content = styled.div`
    padding: 16px;
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
`;

export const CheckButton = styled.button<{
    $selected: boolean;
    $checkColor: string;
    $disabled?: boolean;
}>`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid ${({ $checkColor }) => $checkColor};
    background: ${({ $selected, $checkColor }) => ($selected ? $checkColor : 'transparent')};
    padding: 0;
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    flex: 0 0 20px;
    position: relative;

    /* checkmark */
    &::after {
        content: '';
        display: ${({ $selected }) => ($selected ? 'block' : 'none')};
        position: absolute;
        left: 6px;
        top: 2px;
        width: 5px;
        height: 10px;
        border: solid #ffffff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
`;

export const IconWrap = styled.div<{ $iconBgColor: string }>`
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: ${({ $iconBgColor }) => $iconBgColor};
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 28px;
`;

export const TitleDesc = styled.div`
    flex: 1 1 auto;
`;

export const Title = styled.div`
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
`;

export const Description = styled.div`
    margin-top: 4px;
    font-size: 14px;
    line-height: 18px;
    color: #6b7280;
`;

export const FieldsGrid = styled.div`
    margin-top: 14px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 16px;

    @media ${({ theme }) => theme.screenSizes.tablet} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const FieldBlock = styled.div`
    min-width: 0;
`;

export const FieldLabel = styled.div`
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    color: #0f766e;
    margin-bottom: 6px;
`;

export const InputWrap = styled.div<{ $error?: boolean }>`
    width: 100%;
    height: 40px;
    border-radius: 8px;
    border: 1px solid ${({ $error }) => ($error ? '#EF4444' : '#e5e7eb')};
    background: ${({ $error }) => ($error ? '#FEF2F2' : '#ffffff')};
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const Prefix = styled.span`
    color: #6b7280;
    font-size: 14px;
    line-height: 18px;
    user-select: none;
`;

export const Input = styled.input`
    width: 100%;
    border: 0;
    outline: 0;
    font-size: 14px;
    line-height: 18px;
    background: transparent;
    min-width: 0;
    margin: 0 10px;
`;

export const Select = styled.select`
    width: 100%;
    border: 0;
    outline: 0;
    font-size: 14px;
    line-height: 18px;
    background: transparent;
    min-width: 0;
    margin: 0 10px;
    cursor: pointer;
`;

export const Helper = styled.div<{ $error?: boolean }>`
    margin-top: 6px;
    font-size: 12px;
    line-height: 16px;
    color: ${({ $error }) => ($error ? '#EF4444' : '#6b7280')};
`;

